<template>
  <div class="coupon-nouse">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="暂无更多数据"
      @load="onLoad"
    >
      <div
        class="coupon-item"
        :code="item.classify"
        v-for="item in couponList"
        :key="item.id"
      >
        <div class="coupon-info">
          <div class="coupon-amount">
            <div class="coupon-amount-info">
              <span>¥</span>
              <span>{{ item.amount.slice(1) }}</span>
            </div>
            <div class="use-desc">
              <h1>{{ item.enableAmount }}</h1>

              <div class="classify-style">
                <span class="tag">{{
                  item.classify | couponClassifyMaps
                }}</span>
                <div
                  @click="transformCoupon(item)"
                  class="coupon-change"
                  v-if="item.classify == 'COMMON'"
                >
                  <span>去转换</span>
                  <img src="@/assets/images/coupon-change-arrow.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="type-use">
            <div class="type-name">{{ item.classify | couponTypeMaps }}</div>
            <div class="use-btn" @click="goToRecharge">去使用</div>
          </div>
        </div>
        <div class="coupon-time" :code="item.classify">
          {{ item.expiresTime }}
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { requestMethods } from "@m/api";
export default {
  data() {
    return {
      couponList: [],
      loading: false,
      finished: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  props: {
    currentIndex: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["userInfo", "uuid"]),
  },
  filters: {
    couponTypeMaps(val) {
      if (val == "COMMON") {
        return "通用券";
      }
      if (val == "UNIVERSAL") {
        return "万能券";
      }
      if (val == "CONTINUE_CHARGE") {
        return "续充券";
      }
      if (val == "FIRST_CHARGE") {
        return "首充券";
      }
    },
    couponClassifyMaps(val) {
      if (val == "COMMON") {
        return "全类别通用";
      }
      if (val == "UNIVERSAL") {
        return "全平台可用";
      }
      if (val == "CONTINUE_CHARGE") {
        return "仅限续充使用";
      }
      if (val == "FIRST_CHARGE") {
        return "仅限首充使用";
      }
    },
  },
  methods: {
    resetList() {
      this.currentPage = 1; // 重置页码为第一页
      this.finished = false; // 重置 finished 状态
      this.couponList = []; // 清空当前列表
      this.totalCount = 0;
    },

    async onLoad() {
      this.loading = true;
      const { data, totalCount } = await this.couponListQr();
      this.couponList = [...this.couponList, ...data];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize);
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },
    async couponListQr() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/coupon/userCoupon/getUserCouponList.htm",
          "post",
          {
            uuid: this.uuid,
            status: this.currentIndex,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          }
        );
        return {
          data: data,
          totalCount: totalCount,
        };
      } catch (err) {
        // 通过 err.message 获取到错误信息
        this.$toast(err.message);
      }
    },

    /**
     * 优惠券转换
     */
    transformCoupon(item) {
      this.$dialog
        .confirm({
          title: "温馨提示",
          width: "280px",
          message:
            "万能券不受折扣限制，但转换后券金额会减少为原来的80%（向下取整），不可恢复。确定转换吗？",
          confirmButtonColor: "#FF7A3E",
          beforeClose: this.beforeClose,
        })
        .then(async () => {
          try {
            await requestMethods(
              "/modules/coupon/userCoupon/transformCoupon.htm",
              "post",
              {
                uuid: this.uuid,
                appType: "WM",
                userCouponId: item.id,
              }
            );
            this.$toast("转换成功！");
            this.resetList(); // 重置数据
            this.onLoad(); // 重新加载第一页数据
          } catch (err) {
            this.$toast(err.message);
          }
        });
    },

    goToRecharge() {
      this.$router.push({
        path: "/recharge",
        query: {
          page: "quick",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-nouse {
  .coupon-item {
    width: 710px;
    height: 200px;
    padding: 32px 32px 30px 32px;
    margin-bottom: 20px;

    &[code="COMMON"] {
      background: url("~@/assets/images/bg_coupon_one.png");
      background-size: 100% 100%;
    }
    &[code="FIRST_CHARGE"] {
      background: url("~@/assets/images/bg_coupon_two.png");
      background-size: 100% 100%;
    }
    &[code="CONTINUE_CHARGE"] {
      background: url("~@/assets/images/bg_coupon_three.png");
      background-size: 100% 100%;
    }
    &[code="UNIVERSAL"] {
      background: url("~@/assets/images/bg_coupon_four.png");
      background-size: 100% 100%;
    }

    .coupon-info {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .coupon-amount {
        display: flex;
        align-items: flex-start;

        .coupon-amount-info {
          display: flex;
          align-items: flex-start;
          margin-right: 40px;

          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 50px;
            color: #ffffff;
            line-height: 50px;

            &:last-child {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 110px;
              color: #ffffff;
              line-height: 90px;
            }
          }
        }
        .use-desc {
          h1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 40px;
            color: #ffffff;
            line-height: 56px;
          }

          .classify-style {
            display: flex;
            align-items: center;
            margin-top: 5px;
            .tag {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 24px;
              color: #ffffff;
              line-height: 33px;
              display: block;
              opacity: 0.5;
            }

            .coupon-change {
              display: flex;
              align-items: center;
              background: rgba(255, 255, 255, 0.7);
              border-radius: 17px;
              padding: 0 8px;
              margin-left: 5px;

              span {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 24px;
                color: #ff7d4a;
                line-height: 33px;
              }

              img {
                width: 8px;
                height: 15px;
                margin-left: 5px;
              }
            }
          }
        }
      }
      .type-use {
        text-align: center;
      }
      .type-name {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 30px;
        color: #ffffff;
        margin-bottom: 28px;
      }
      .use-btn {
        width: 170px;
        height: 60px;
        border-radius: 30px;
        border: 2px solid #ffffff;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 30px;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
      }
    }
    .coupon-time {
      width: 307px;
      height: 31px;
      background: url("~@/assets/images/time-bg.png");
      background-size: 100% 100%;
      line-height: 31px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 22px;
      color: #ff7a3e;
      margin-left: -32px;
      padding-left: 31px;
      margin-top: -12px;

      &[code="COMMON"] {
        color: #ff7a3e;
      }
      &[code="FIRST_CHARGE"] {
        color: #0091ff;
      }
      &[code="CONTINUE_CHARGE"] {
        color: #9368ff;
      }
      &[code="UNIVERSAL"] {
        color: #f1928a;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/coupon/components/NoUse.vue